var app = app || {};
(function () {
    app.utils = app.utils || {};

    app.utils.string = {
        truncate: function (str, maxLength, postfix) {
            if (!str || !maxLength || str.length <= maxLength) {
                return str;
            }

            if (postfix === false) {
                return str.substr(0, maxLength);
            }

            return str.substr(0, maxLength - 1) + "&#133;";
        },
        toBase64: function (arrayBuffer) {
            // convert from an array buffer to a base64 string
            // https://www.isummation.com/blog/convert-arraybuffer-to-base64-string-and-vice-versa/
            const binaryChars = Array(arrayBuffer.byteLength);
            const bufferView = new Uint8Array(arrayBuffer);
            for (let i = 0, len = bufferView.byteLength; i < len; i++) {
                binaryChars[i] = String.fromCharCode(bufferView[i]);
            }
            const binaryString = binaryChars.join("");
            return window.btoa(binaryString);
        },
        fromBase64: function (base64) {
            // convert from a base64 string to an array buffer
            // https://www.isummation.com/blog/convert-arraybuffer-to-base64-string-and-vice-versa/
            const binaryString = window.atob(base64);
            const arrayBuffer = new ArrayBuffer(binaryString.length);
            const bufferView = new Uint8Array(arrayBuffer);
            for (let i = 0, len = binaryString.length; i < len; i++) {
                bufferView[i] = binaryString.charCodeAt(i);
            }
            return bufferView.buffer;
        }
    };

    app.utils.dateTime = {
        containsTime: function (date) {
            if (!date) {
                return false;
            }

            return date.indexOf(":") !== -1;
        },

        getEndOfDay: function (date) {
            if (!date || !window.moment) {
                return null;
            }

            return window.moment(date).endOf("day");
        },

        getEndOfDayIfTimeNotExists: function (date) {
            if (this.containsTime(date)) {
                return date;
            }

            return this.getEndOfDay(date);
        },

        getTicks: function (date) {
            return (date.getTime() * 10000) + 621355968000000000;
        },

        formatShortDateShortTime: function (dateTime) {
            return `${abp.dateTimeFormatter.formatShortDate(dateTime)} ${abp.dateTimeFormatter.formatShortTime(dateTime)}`;
        },
        formatShortDateLongTime: function (dateTime) {
            return `${abp.dateTimeFormatter.formatShortDate(dateTime)} ${abp.dateTimeFormatter.formatLongTime(dateTime)}`;
        },
        formatShortDate2ShortTime: function (dateTime) {
            return `${abp.dateTimeFormatter.formatShortDate2(dateTime)} ${abp.dateTimeFormatter.formatShortTime(dateTime)}`;
        },
        formatShortDate2LongTime: function (dateTime) {
            return `${abp.dateTimeFormatter.formatShortDate2(dateTime)} ${abp.dateTimeFormatter.formatLongTime(dateTime)}`;
        },
        formatLongDateShortTime: function (dateTime) {
            return `${abp.dateTimeFormatter.formatLongDate(dateTime)} ${abp.dateTimeFormatter.formatShortTime(dateTime)}`;
        },
        formatLongDateLongTime: function (dateTime) {
            return `${abp.dateTimeFormatter.formatLongDate(dateTime)} ${abp.dateTimeFormatter.formatLongTime(dateTime)}`;
        },
        formatLong2DateShortTime: function (dateTime) {
            return `${abp.dateTimeFormatter.formatLongDate2(dateTime)} ${abp.dateTimeFormatter.formatShortTime(dateTime)}`;
        },
        formatLong2DateLongTime: function (dateTime) {
            return `${abp.dateTimeFormatter.formatLongDate2(dateTime)} ${abp.dateTimeFormatter.formatLongTime(dateTime)}`;
        },

        /**
         * @description Gets the duration of two dates
         * @param {(Date|string)} fromDate - If it's a string, make sure it's in ISO 8601 format. Eg: 2021-02-03T05:33:21Z / 2021-02-03T13:33:21+08:00
         * @param {(Date|string)} toDate - If it's a string, make sure it's in ISO 8601 format. Eg: 2021-02-03T05:33:21Z / 2021-02-03T13:33:21+08:00
         * @returns {object} - An object that contains the data of the duration.
         */
        getDuration: function (fromDate, toDate = null) {
            const toDateMoment = toDate ? window.moment(toDate).local() : window.moment().local();
            toDateMoment.set({ hour: 24, minute: 0, second: 0 });

            const fromDateMoment = window.moment(fromDate).local();
            fromDateMoment.set({ hour: 0, minute: 0, second: 0 });

            //const diffDuration = window.moment.duration(toDateMoment.diff(fromDateMoment));

            //const duration = {
            //    years: diffDuration.years(),
            //    months: diffDuration.months(),
            //    days: diffDuration.days()
            //};

            let duration = window.moment.preciseDiff(fromDateMoment, toDateMoment, true);

            if (duration.firstDateWasLater || (duration.years === 0 && duration.months === 0 && duration.days === 0)) {
                //toDateMoment.add(-1, "day");
                fromDateMoment.add(1, "day");

                duration = window.moment.preciseDiff(fromDateMoment, toDateMoment, true);

                if (duration.years) {
                    duration.years = 0 - duration.years;
                } else if (duration.months) {
                    duration.months = 0 - duration.months;
                } else if (duration.days) {
                    duration.days = 0 - duration.days;
                }
            }

            return duration;
        }
    };
    app.utils.dateTime.getDuration.asString = function (fromDate, toDate = null) {
        const duration = app.utils.dateTime.getDuration(fromDate, toDate);

        const parts = [];
        if (duration.years) {
            parts.push(app.localize(Math.abs(duration.years) > 1 ? "Duration.Part.Year.Plural" : "Duration.Part.Year.Singular", duration.years));
        }
        if (duration.months) {
            parts.push(app.localize(Math.abs(duration.months) > 1 ? "Duration.Part.Month.Plural" : "Duration.Part.Month.Singular", duration.months));
        }
        if (duration.days) {
            parts.push(app.localize(Math.abs(duration.days) > 1 ? "Duration.Part.Day.Plural" : "Duration.Part.Day.Singular", duration.days));
        }

        return _.join(parts, " ");
    };
    app.utils.dateTime.getDuration.asHtml = function (fromDate, toDate = null) {
        const duration = app.utils.dateTime.getDuration(fromDate, toDate);
        
        const parts = [];
        if (duration.years) {
            parts.push(app.localize(Math.abs(duration.years) > 1 ? "Duration.Part.Year.Plural" : "Duration.Part.Year.Singular", `<span class="${(duration.firstDateWasLater ? "text-danger" : "text-success")}">${duration.years}</span>`));
        }
        if (duration.months) {
            parts.push(app.localize(Math.abs(duration.months) > 1 ? "Duration.Part.Month.Plural" : "Duration.Part.Month.Singular", `<span class="${(duration.firstDateWasLater ? "text-danger" : "text-success")}">${duration.months}</span>`));
        }
        if (duration.days) {
            parts.push(app.localize(Math.abs(duration.days) > 1 ? "Duration.Part.Day.Plural" : "Duration.Part.Day.Singular", `<span class="${(duration.firstDateWasLater ? "text-danger" : "text-success")}">${duration.days}</span>`));
        }

        return _.join(parts, " ");
    };

    app.utils.html = {
        htmlEncodeText: function (value) {
            return $("<div/>").text(value).html();
        },

        htmlDecodeText: function (value) {
            return $("<div/>").html(value).text();
        },

        htmlEncodeJson: function (jsonObject) {
            return JSON.parse(app.utils.html.htmlEncodeText(JSON.stringify(jsonObject)));
        },

        htmlDecodeJson: function (jsonObject) {
            return JSON.parse(app.utils.html.htmlDecodeText(JSON.stringify(jsonObject)));
        }
    };

    app.utils.theme = {
        getFixedHeaderOffset: function () {
            var subheaderHeight = 0;
            var headerHeight = 0;

            if (window.KTUtil.isDesktopDevice()) {
                if (window.KTLayoutHeader && window.KTLayoutHeader.isFixed()) {
                    const $header = $("body.header-fixed .header");
                    const $headerChildren = $header.children(":visible");
                    if ($headerChildren.length > 0) {
                        $headerChildren.each(function () {
                            headerHeight += $(this).outerHeight(true);
                        });
                    } else {
                        headerHeight = $header.outerHeight();
                    }
                }

                if (window.KTLayoutSubheader && window.KTLayoutSubheader.isFixed()) {
                    const $subheader = $("body.subheader-fixed .subheader, body.header-fixed .header-bottom");
                    subheaderHeight = $subheader.outerHeight();
                }
            } else if (window.KTUtil.isMobileDevice()) {
                if (window.KTLayoutHeader && window.KTLayoutHeader.isFixedForMobile()) {
                    headerHeight = window.KTLayoutHeader.getHeightForMobile();

                    if ($("body").hasClass("topbar-mobile-on")) {
                        subheaderHeight = window.KTUtil.actualHeight($(".topbar-mobile-on .topbar").get(0), false);;
                    }
                }
            }

            const totalHeaderHeight = subheaderHeight + headerHeight;
            return totalHeaderHeight > 0 ? totalHeaderHeight - 1 : 0;
        },
        getFixedFooterOffset: function () {
            var footerHeight = 0;

            if (window.KTUtil.isDesktopDevice()) {
                const $footer = $("body.footer-fixed .footer");
                if ($footer.length) {
                    footerHeight = window.KTLayoutFooter ? window.KTLayoutFooter.getHeight() : 0;
                }
            } else if (window.KTUtil.isMobileDevice()) {
                const $footer = $("body.footer-mobile-fixed .footer-mobile");
                if ($footer.length) {
                    footerHeight = window.KTUtil.actualHeight($footer.get(0), false);
                }
            }

            return footerHeight;
        },
        isContentScrolledToBottom: function (element, offsetInPixels = 0) {
            if (!offsetInPixels) {
                offsetInPixels = 0;
            }

            const rest = element.scrollHeight - element.scrollTop;
            return Math.abs(element.clientHeight - rest) <= 1 + offsetInPixels;
        },
        scrollToTop: function (element) {
            $(element).stop().animate({
                scrollTop: 0
            }, "fast");
        },
        scrollToBottom: function (element) {
            $(element).stop().animate({
                scrollTop: $(element).get(0).scrollHeight
            }, "fast");
        }
    };

    /**
       * parameterInfos should be an array of { name, value } objects
       * where name is query string parameter name and value is it's value.
       * includeQuestionMark is true by default.
       */
    abp.utils.buildQueryString = function (parameterInfos, includeQuestionMark) {
        if (includeQuestionMark === undefined) {
            includeQuestionMark = true;
        }

        var qs = "";

        function addSeperator() {
            if (!qs.length) {
                if (includeQuestionMark) {
                    qs = qs + "?";
                }
            } else {
                qs = qs + "&";
            }
        }

        function hasValue(obj) {
            if (typeof obj === "object") {
                for (let key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        return true;
                    }
                }
                return false;
            }
            if (typeof obj === "boolean") {
                return true;
            }
            if (typeof obj === "number") {
                return true;
            }
            return (typeof (obj) != "undefined" && obj != null && obj);
        }

        for (let i = 0; i < parameterInfos.length; ++i) {
            const parameterInfo = parameterInfos[i];
            if (parameterInfo.value === undefined) {
                continue;
            }

            if (parameterInfo.value === null) {
                parameterInfo.value = "";
            }

            if (parameterInfo.value.toJSON && typeof parameterInfo.value.toJSON === "function") {
                addSeperator();
                qs = qs + parameterInfo.name + "=" + encodeURIComponent(parameterInfo.value.toJSON());
            } else if (Array.isArray(parameterInfo.value) && parameterInfo.value.length) {
                addSeperator();
                for (let j = 0; j < parameterInfo.value.length; j++) {
                    if (j > 0) {
                        addSeperator();
                    }

                    if (hasValue(parameterInfo.value[j])) {
                        qs = qs + parameterInfo.name + "=" + encodeURIComponent(parameterInfo.value[j]);
                    }
                }
            } else if (hasValue(parameterInfo.value)) {
                addSeperator();
                qs = qs + parameterInfo.name + "=" + encodeURIComponent(parameterInfo.value);
            }
        }

        return qs;
    };
})();
